import React from 'react';
import { Button } from './ui/Button';
interface FinalCTAProps {
  onBookConsultation?: () => void;
}
export function FinalCTA({
  onBookConsultation
}: FinalCTAProps) {
  return <section className="bg-espresso py-20 md:py-32 px-4 text-center" data-id="element-82">
      <div className="max-w-4xl mx-auto flex flex-col items-center" data-id="element-83">
        <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl text-cream font-light mb-10 leading-tight" data-id="element-84">
          Your hair, restored. By you.
        </h2>

        <Button variant="primary" className="w-full md:w-auto shadow-2xl shadow-black/50" onClick={onBookConsultation} data-id="element-85">
          Book My Free Consultation
        </Button>
      </div>
    </section>;
}